module.exports = __webpack_public_path__ + "img/accessory2_active.5b7b76b1.svg";